import { stepTitles } from '@/mocks/questionnaire';

interface StepProgressProps {
  step: number;
  onJump: (step: number) => void;
}

export default function StepProgress({ step, onJump }: StepProgressProps) {
  const percent = Math.round((step / stepTitles.length) * 100);

  return (
    <div className="bg-background-50 rounded-xl border border-secondary-200/70 px-4 py-3">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs text-foreground-500">
          步骤 {step}/{stepTitles.length}:{stepTitles[step - 1]}
        </span>
        <span className="text-xs font-medium text-primary-600">{percent}%</span>
      </div>

      <div className="w-full h-1.5 bg-secondary-100 rounded-full overflow-hidden mb-3">
        <div
          className="h-full bg-primary-500 rounded-full transition-all duration-500"
          style={{ width: `${percent}%` }}
        />
      </div>

      <div className="flex items-start justify-between gap-1">
        {stepTitles.map((title, index) => {
          const current = index + 1;
          const done = current < step;
          const active = current === step;
          return (
            <button
              key={title}
              type="button"
              onClick={() => onJump(current)}
              className="flex flex-col items-center gap-1 cursor-pointer group flex-1 min-w-0"
            >
              <span
                className={`w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-semibold transition-all shrink-0 ${
                  active
                    ? 'bg-primary-500 text-background-50 shadow-md shadow-primary-200/60'
                    : done
                      ? 'bg-primary-200 text-primary-700'
                      : 'bg-secondary-100 text-foreground-400 group-hover:bg-secondary-200'
                }`}
              >
                {done ? <i className="ri-check-line text-[11px]"></i> : current}
              </span>
              <span
                className={`text-[10px] transition-colors text-center leading-tight ${
                  active
                    ? 'text-primary-600 font-medium'
                    : done
                      ? 'text-foreground-500'
                      : 'text-foreground-300'
                }`}
              >
                {title}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}